window.BeitoFreemotionWeightSize = {
"Appenzell Cattle Dog":[[1,3,null],[4,9,3],[10,16,4],[17,23,5],[24,30,6],[31,37,7],[38,44,8],[45,51,9],[52,60,null]],
"American Akita":[[1,1,4],[2,3,null],[4,7,4],[8,15,5],[16,24,6],[25,32,7],[33,41,8],[42,49,9],[50,60,null]],
"American Cocker Spaniel":[[1,3,null],[4,10,3],[11,17,4],[18,23,5],[24,30,6],[31,37,7],[38,44,8],[45,50,9],[51,60,null]],
"Affenpinscher":[[1,7,null],[8,11,3],[12,14,4],[15,18,5],[19,21,6],[22,24,7],[25,27,8],[28,31,9],[32,60,null]],
"Boxer":[[1,3,null],[4,9,3],[10,15,4],[16,22,5],[23,28,6],[29,34,7],[35,40,8],[41,46,9],[47,100,null]],
"French Bulldog":[[8,14,3]],
"Afghan Hound":[[1,1,4],[2,3,null],[4,7,4],[8,15,5],[16,24,6],[25,32,7],[33,41,8],[42,49,9],[50,60,null]],
"Airedale Terrier":[[1,7,null],[8,13,3],[14,19,4],[20,25,5],[26,31,6],[32,37,7],[38,42,8],[43,48,9],[49,60,null]],
"Akita":[[1,1,4],[2,3,null],[4,12,5],[13,24,6],[25,35,7],[36,47,8],[48,58,9],[59,60,null]],
"Alaskan Husky":[[1,4,null],[5,11,3],[12,17,4],[18,24,5],[25,30,6],[31,37,7],[38,44,8],[45,50,9],[51,60,null]],
"Alaskan Malamute":[[1,1,4],[2,3,null],[4,7,4],[8,15,5],[16,24,6],[25,32,7],[33,41,8],[42,49,9],[50,60,null]],
"American Foxhound":[[1,1,4],[2,3,null],[4,7,4],[8,15,5],[16,24,6],[25,32,7],[33,41,8],[42,49,9],[50,60,null]],
"American Staffordshire Terrier":[[1,1,4],[2,3,null],[4,7,4],[8,15,5],[16,24,6],[25,32,7],[33,41,8],[42,49,9],[50,60,null]],
"American Water Spaniel":[[1,3,null],[4,10,3],[11,17,4],[18,23,5],[24,30,6],[31,37,7],[38,44,8],[45,50,9],[51,60,null]],
"Australian Cattle Dog":[[1,5,null],[6,11,3],[12,18,4],[19,24,5],[25,31,6],[32,37,7],[38,44,8],[45,50,9],[51,60,null]],
"Australian Kelpie":[[1,7,null],[8,13,3],[14,18,4],[19,24,5],[25,30,6],[31,36,7],[37,42,8],[43,48,9],[49,60,null]],
"Australian Shepherd":[[1,6,null],[7,12,3],[13,18,4],[19,24,5],[25,30,6],[31,36,7],[37,42,8],[43,48,9],[49,60,null]],
"Australian Stumpy Tail Cattle Dog":[[1,3,null],[4,10,3],[11,17,4],[18,23,5],[24,30,6],[31,37,7],[38,44,8],[45,50,9],[51,60,null]],
"Australian Terrier":[[1,3,null],[4,10,3],[11,17,4],[18,23,5],[24,30,6],[31,37,7],[38,44,8],[45,50,9],[51,60,null]],
"Azawakh":[[1,3,null],[4,10,3],[11,17,4],[18,23,5],[24,30,6],[31,37,7],[38,44,8],[45,50,9],[51,60,null]],
"Basenji":[[1,3,null],[4,10,3],[11,17,4],[18,23,5],[24,30,6],[31,37,7],[38,44,8],[45,50,9],[51,60,null]],
"Basset Hound":[[1,6,null],[7,12,3],[13,19,4],[20,25,5],[26,32,6],[33,38,7],[39,45,8],[46,51,9],[52,60,null]],
"Bavarian Mountain Scent Hound":[[16,19,5],[20,24,6],[25,28,7],[29,30,8]],
"Bearded Collie":[[1,7,null],[8,13,3],[14,18,4],[19,24,5],[25,30,6],[31,36,7],[37,42,8],[43,48,9],[49,60,null]],
"Bedlington Terrier":[[1,3,null],[4,10,3],[11,17,4],[18,23,5],[24,30,6],[31,37,7],[38,44,8],[45,50,9],[51,60,null]],
"Bernese Mountain Dog":[[1,1,4],[2,3,null],[4,7,4],[8,15,5],[16,24,6],[25,32,7],[33,41,8],[42,49,9],[50,60,null]],
"Bloodhound":[[1,1,4],[2,3,null],[4,7,4],[8,15,5],[16,24,6],[25,32,7],[33,41,8],[42,49,9],[50,60,null]],
"Blue Picardy Spaniel":[[20,23,5],[24,25,6]],
"Border Collie":[[13,13,3],[14,18,4],[19,24,5],[25,25,6]],
"Border Terrier":[[1,1,3],[2,3,null],[4,100,3]],
"Boston Terrier":[[5,10,3],[11,12,4]],
"Briard":[[24,24,6],[25,32,7],[33,41,8],[42,46,9]],
"Brittany":[[13,13,3],[14,18,4],[19,19,5]],
"Broholmer":[[40,41,8],[42,49,9]],
"Bull Terrier":[[22,24,5],[25,30,6],[31,32,7]],
"Bulldog":[[18,23,6]],
"Bullmastiff":[[45,49,9]],
"Cairn Terrier":[[5,7,3]],
"Chihuahua":[[1,100,null]],
"Canaan Dog":[[15,15,5],[16,24,6],[25,25,7]],
"Canadian Eskimo Dog":[[18,24,6],[25,32,7],[33,40,8]],
"Caucasian Shepherd Dog":[[44,49,9]],
"Cavalier King Charles Spaniel":[[5,9,3]],
"Cesky Terrier":[[6,10,3],[11,11,4]],
"Chesapeake Bay Retriever":[[24,25,5],[26,30,6],[31,35,7],[36,37,8]],
"Chow Chow":[[20,24,6],[25,32,7]],
"Cirneco dell'Etna":[[8,10,3],[11,13,4]],
"Clumber Spaniel":[[24,24,6],[25,28,7],[29,32,8],[33,36,9]],
"Curly-Coated Retriever":[[27,30,6],[31,37,7],[38,44,8]],
"Dachshund":[[1,5,null],[6,11,3],[12,17,4],[18,22,5],[23,28,6],[29,33,7],[34,39,8],[40,45,9],[46,100,null]],
"Dalmatian":[[20,22,5],[23,29,6],[30,32,7]],
"Dandie Dinmont Terrier":[[8,10,3],[11,11,4]],
"Danish-Swedish Farmdog":[[6,10,3]],
"Doberman Pinscher":[[27,29,6],[30,34,7],[35,40,8],[41,46,9]],
"Dogo Argentino":[[36,41,8],[42,46,9]],
"Dogue de Bordeaux":[[44,49,9]],
"Drever":[[15,17,4],[18,19,5]],
"Dutch Shepherd":[[19,23,5],[24,30,6],[31,34,7]],
"English Cocker Spaniel":[[11,16,4]],
"English Foxhound":[[27,32,7],[33,34,8]],
"English Setter":[[20,24,5],[25,31,6],[32,37,7]],
"English Springer Spaniel":[[18,19,3],[20,23,4]],
"Entlebucher Mountain Dog":[[1,3,null],[4,10,3],[11,17,4],[18,23,5],[24,30,6],[31,37,7],[38,44,8],[45,50,9],[51,100,null]],
"Estrela Mountain Dog":[[34,41,8],[42,49,9]],
"Eurohound":[[18,23,5],[24,30,6],[31,34,7]],
"Field Spaniel":[[15,17,4],[18,23,5]],
"Finnish Spitz":[[9,11,3],[12,15,4]],
"German Pinscher":[[11,17,4],[18,21,5]],
"German Shepherd Dog":[[1,1,4],[2,3,null],[4,7,4],[8,15,5],[16,24,6],[25,32,7],[33,41,8],[42,49,9],[50,100,null]],
"German Wirehaired Pointer":[[22,23,5],[24,30,6],[31,32,7]],
"Giant Schnauzer":[[24,24,6],[25,32,7],[33,41,8],[42,44,9]],
"Glen of Imaal Terrier":[[14,15,4],[16,19,5]],
"Golden Retriever":[[1,3,null],[4,9,3],[10,16,4],[17,23,5],[24,30,6],[31,37,7],[38,44,8],[45,51,9],[52,100,null]],
"Gordon Setter":[[20,24,6],[25,32,7],[33,37,8]],
"Grand Basset Griffon Vendéen":[[18,21,5]],
"Great Dane":[[1,1,5],[2,3,null],[4,16,6],[17,31,7],[32,46,8],[47,61,9],[62,100,null]],
"Greyhound":[[1,1,4],[2,3,null],[4,7,4],[8,15,5],[16,24,6],[25,32,7],[33,41,8],[42,49,9],[50,100,null]],
"Greyster":[[16,22,5],[23,29,6],[30,35,7]],
"Hamiltonstovare":[[18,23,5],[24,30,6],[31,34,7]],
"Hanoverian Scenthound":[[35,41,8],[42,45,9]],
"Norwegian Elkhound":[[21,24,5],[25,25,6]],
"Harrier":[[20,24,6],[25,28,7]],
"Hokkaido":[[20,24,6],[25,30,7]],
"Hovawart":[[29,32,7],[33,41,8]],
"Icelandic Sheepdog":[[11,14,4]],
"Irish Red and White Setter":[[15,17,4],[18,23,5],[24,28,6]],
"Irish Terrier":[[11,13,3]],
"Irish Water Spaniel":[[20,24,6],[25,31,7]],
"Irish Wolfhound":[[47,55,9]],
"Jack Russell Terrier":[[1,7,null],[8,11,3],[12,15,4],[16,19,5],[20,24,6],[25,28,7],[29,32,8],[33,36,9],[37,100,null]],
"Japanese Chin":[[5,5,3]],
"Japanese Spitz":[[4,10,3],[11,12,4]],
"Japanese Terrier":[[4,6,3]],
"Kai Ken":[[11,17,4],[18,19,5]],
"Karelian Bear Dog":[[20,23,6]],
"Kerry Blue Terrier":[[15,19,4]],
"Kishu Ken":[[13,17,4],[18,23,5],[24,28,6]],
"Korean Jindo Dog":[[13,17,4],[18,23,5]],
"Kromfohrlander":[[9,11,3],[12,15,4],[16,16,5]],
"Kuvasz":[[31,32,7],[33,41,8],[42,49,9]],
"Labrador Retriever":[[24,29,6],[30,36,7],[37,37,8]],
"Lancashire Heeler":[[4,8,3]],
"Large Munsterlander":[[22,24,5],[25,30,6],[31,32,7]],
"Leonberger":[[40,48,8],[49,60,9]],
"Lhasa Apso":[[5,9,3]],
"Miniature American Shepherd":[[9,10,3],[11,17,4],[18,19,5]],
"Miniature Bull Terrier":[[8,10,3],[11,13,4]],
"Mudi":[[8,10,3],[11,14,4]],
"Neapolitan Mastiff":[[49,49,9]],
"Newfoundland":[[45,46,8],[47,58,9]],
"Norwegian Buhund":[[11,12,3],[13,18,4],[19,19,5]],
"Norwegian Lundehund":[[5,9,3]],
"Nova Scotia Duck Tolling Retriever":[[15,18,4],[19,23,5]],
"Old English Sheepdog":[[27,31,6],[32,37,7],[38,44,8],[45,46,9]],
"Otterhound":[[36,41,8],[42,49,9]],
"Pharaoh Hound":[[20,24,6],[25,25,7]],
"Polish Lowland Sheepdog":[[13,17,4],[18,23,5]],
"Pont-Audemer Spaniel":[[15,17,4],[18,22,5]],
"Porcelaine":[[24,24,6],[25,29,7]],
"Portuguese Sheepdog":[[17,17,4],[18,23,5],[24,27,6]],
"Portuguese Water Dog":[[15,19,4],[20,26,5],[27,28,6]],
"Pudelpointer":[[20,24,6],[25,32,7]],
"Russell Terrier":[[35,35,9]]
,
"Ariege Pointing Dog":[[1,3,null],[4,10,3],[11,17,4],[18,23,5],[24,30,6],[31,37,7],[38,44,8],[45,50,9],[51,60,null]]
,
"Ariegeois":[[1,3,null],[4,10,3],[11,17,4],[18,23,5],[24,30,6],[31,37,7],[38,44,8],[45,50,9],[51,60,null]]
,
"Artois Hound":[[1,3,null],[4,10,3],[11,17,4],[18,23,5],[24,30,6],[31,37,7],[38,44,8],[45,50,9],[51,60,null]]
,
"Atlas Mountain Dog (Aidi)":[[1,3,null],[4,10,3],[11,17,4],[18,23,5],[24,30,6],[31,37,7],[38,44,8],[45,50,9],[51,60,null]]
,
"Australian Silky Terrier":[[1,60,null]]
,
"Austrian Black And Tan Hound":[[1,3,null],[4,10,3],[11,17,4],[18,23,5],[24,30,6],[31,37,7],[38,44,8],[45,50,9],[51,60,null]]
,
"Austrian Pinscher":[[1,7,null],[8,11,3],[12,15,4],[16,19,5],[20,24,6],[25,28,7],[29,32,8],[33,36,9],[37,60,null]]
,
"Auvergne Pointer":[[1,3,null],[4,10,3],[11,17,4],[18,23,5],[24,30,6],[31,37,7],[38,44,8],[45,50,9],[51,60,null]]
,
"Basset Fauve De Bretagne":[[1,3,null],[4,10,3],[11,17,4],[18,23,5],[24,30,6],[31,37,7],[38,44,8],[45,50,9],[51,60,null]]
,
"Beagle":[[1,3,null],[4,9,3],[10,16,4],[17,23,5],[24,29,6],[30,36,7],[37,43,8],[44,49,9],[50,60,null]]
,
"Beagle Harrier":[[1,3,null],[4,10,3],[11,17,4],[18,23,5],[24,30,6],[31,37,7],[38,44,8],[45,50,9],[51,60,null]]
,
"Belgian Shepherd Dog":[[1,3,null],[4,9,3],[10,16,4],[17,23,5],[24,30,6],[31,37,7],[38,44,8],[45,51,9],[52,60,null]]
,
"Bergamasco Shepherd Dog":[[1,3,null],[4,10,3],[11,17,4],[18,23,5],[24,30,6],[31,37,7],[38,44,8],[45,50,9],[51,60,null]]
,
"Berger De Beauce":[[1,1,4],[2,3,null],[4,7,4],[8,15,5],[16,24,6],[25,32,7],[33,41,8],[42,49,9],[50,60,null]]
,
"Bichon Frise":[[1,60,null]]
,
"Billy":[[1,3,null],[4,10,3],[11,17,4],[18,23,5],[24,30,6],[31,37,7],[38,44,8],[45,50,9],[51,60,null]]
,
"Black And Tan Coonhound":[[1,1,4],[2,3,null],[4,7,4],[8,15,5],[16,24,6],[25,32,7],[33,41,8],[42,49,9],[50,60,null]]
,
"Blue Gascony Basset":[[1,3,null],[4,10,3],[11,17,4],[18,23,5],[24,30,6],[31,37,7],[38,44,8],[45,50,9],[51,60,null]]
,
"Blue Gascony Griffon":[[1,3,null],[4,10,3],[11,17,4],[18,23,5],[24,30,6],[31,37,7],[38,44,8],[45,50,9],[51,60,null]]
};;

const NSD_FREEMOTION_BREED_ALIASES = {
"Entlebuch Cattle Dog":"Entlebucher Mountain Dog",
"Irish Glen Of Imaal Terrier":"Glen of Imaal Terrier",
"German Wire- Haired Pointing Dog":"German Wirehaired Pointer",
};
function normalizeNsdBreedKey(value) {
return String(value || '').trim().toLowerCase().normalize('NFD')
.replace(/[\u0300-\u036f]/g,'').replace(/[^a-z0-9]/g,'');
}
const NSD_FREEMOTION_OFFICIAL_COEFFICIENTS = Object.create(null);
'0.3,0.1:affenpinscher|0.118577,3.604743:afghanhound,alaskanmalamute,americanakita,americanfoxhound,americanstaffordshireterrier,bergerdebeauce,bernesemountaindog,blackandtancoonhound,bloodhound,borzoirussianhuntingsighthound,bosnianandherzegoviniancroatianshepherddog,bouvierdesflandres,briard,broholmer,bulldog,bullmastiff,canaandog,canadianeskimodog,castrolaboreirodog,caucasianshepherddog,centralasiashepherddog,chowchow,cimarronuruguayo,deerhound,dogoargentino,doguedebordeaux,englishfoxhound,estrelamountaindog,filabrasileiro,frenchspaniel,frenchtricolourhound,germanshepherddog,giantschnauzer,gordonsetter,greatanglofrenchtricolourhound,greatanglofrenchwhiteandblackhound,greatanglofrenchwhiteorangehound,greatgasconyblue,greatswissmountaindog,greyhound,hanoverianscenthound,harrier,hokkaido,hovawart,irishwaterspaniel,italiancanecorso,kangalshepherddog,karelianbeardog,karstshepherddog,komondor,kuvasz,landseereuropeancontinentaltype,lapponianherder,majorcamastiff,maremmaandtheabruzzessheepdog,mastiff,neapolitanmastiff,otterhound,pharaohhound,porcelaine,presacanario,pudelpointer,pyreneanmastiff,rafeiroofalentejo,romanianbucovinashepherd,romaniancarpathianshepherddog,romaniamioriticshepherddog,russianblackterrier,slovakianchuvach,southrussianshepherddog,spanishmastiff,tatrashepherddog,tibetanmastiff,tosa,transmontanomastiff,yugoslavianshepherddogsharplanina|0.16995,1.2118:airedaleterrier,irishsoftcoatedwheatenterrier,irishterrier,kerryblueterrier,lakelandterrier|0.087302,4.380952:akita|0.151943,1.798937:alaskanhusky|0.24286,0.657:alpinedachsbracke,austrianpinscher,bavarianmountainscenthound,bolognese,brazilianterrier,clumberspaniel,dutchschapendoes,dutchsmoushond,englishtoyterrierblacktan,foxterriersmooth,foxterrierwire,germanhuntingterrier,griffonbelge,griffonbruxellois,irishglenofimaalterrier,italiansighthound,italianvolpino,jackrussellterrier,kingcharlesspaniel,kromfohrlander,longhairedpyreneansheepdog,norfolkterrier,norrbottenspitz,norwichterrier,peruvianhairlessdog,petitbrabancon,picardysheepdog,pragueratter,russiantoy,smallswisshound,xoloitzcuintle|0.147984,1.972177:americancockerspaniel,americanwaterspaniel,ariegepointingdog,ariegeois,artoishound,atlasmountaindogaidi,australianstumpytailcattledog,australianterrier,austrianblackandtanhound,auvergnepointer,azawakh,basenji,bassetfauvedebretagne,beagleharrier,bedlingtonterrier,bergamascoshepherddog,billy,bluegasconybasset,bluegasconygriffon,bluepicardyspaniel,bohemianshepherddog,bohemianwirehairedpointinggriffon,bosnianbrokenhairedhoundcalledbarak,bostonterrier,bourbonnaispointingdog,bouvierdesardennes,braziliantracker,briquetgriffonvendeen,burgospointingdog,canarianwarrenhound,catalansheepdog,ceskyterrier,cirnecodelletna,coarsehairedstyrianhound,croatianshepherddog,curlycoatedretriever,czechoslovakianwolfdog,dandiedinmontterrier,danishswedishfarmdog,deutschlanghaar,deutschstichelhaar,drentschepartridgedog,drever,dutchshepherddog,eastsiberianlaika,entlebuchcattledog,estonianhound,eurasian,eurohound,europeansleddog,fawnbrittanygriffon,fieldspaniel,finnishhound,frenchpointingdoggascognetype,frenchpointingdogpyreneantype,frenchwaterdog,frenchwhiteandorangehound,frenchwhiteblackhound,frisianwaterdog,gasconsaintongeois,germanhound,germanpinscher,germanspaniel,germanwirehairedpointingdog,grandbassetgriffonvendeen,grandgriffonvendeen,griffonnivernais,hamiltonstovare,hellenichound,hungariangreyhound,hungarianhoundtransylvanianscenthound,ibizanpodenco,icelandicsheepdog,irishredandwhitesetter,irishredsetter,istrianshorthairedhound,istrianwirehairedhound,italianpointingdog,italianroughhairedsegugio,italianshorthairedsegugio,italianspinone,jamthund,japanesespitz,japaneseterrier,kai,kintamanibalidog,kishu,koreajindodog,lancashireheeler,majorcashepherddog,mediumsizedanglofrenchhound,miniatureamericanshepherd,miniaturebullterrier,montenegrinmountainhound,mudi,normanartesienbasset,norwegianhound,norwegianlundehund,olddanishpointingdog,picardyspaniel,poitevin,polishgreyhound,polishhound,polishhuntingdog,polishlowlandsheepdog,pontaudemerspaniel,portuguesepointingdog,portuguesesheepdog,portuguesewarrenhoundportuguesepodengo,posavatzhound,puli,pumi,romagnawaterdog,russianeuropeanlaika,saarlooswolfhond,saintgermainpointer,saintmiguelcattledog,schillerstovare,sealyhamterrier,segugiomaremmano,serbianhound,serbiantricolourhound,sharpei,shikoku,siberianhusky,skyeterrier,sloughi,slovakianhound,smalandsstovare,smallbluegascony,spanishgreyhound,spanishhound,sussexspaniel,swedishlapphund,swedishvallhund,swisshound,taiwandog,thaibangkaewdog,thairidgebackdog,tibetanspaniel,tibetanterrier,tyroleanhound,welshterrier,westsiberianlaika,westphaliandachsbracke,whiteswissshepherddog,wirehairedpointinggriffonkorthals,wirehairedslovakianpointer,yakutianlaika|0.14286,2.0952:appenzellcattledog,goldenretriever|0.1542,1.668:australiancattledog|0.16996,1.27668:australiankelpie,brittanyspaniel,bullterrier|0.165,1.483:australianshepherd|0,1:australiansilkyterrier,manchesterterrier|0.1544,1.544:bassethound|0.15,2.01:beagle|0.1694,1.2956:beardedcollie,bordercollie,collierough,colliesmooth,kleinermunsterlander,largemunsterlander,novascotiaducktollingretriever,stabijhoun|0.141636,2.171347:belgianshepherddog|0,2:bichonfrise,chinesecresteddog,cotondetulear,havanese,maltese,miniaturepinscher,miniatureschnauzer,parsonrussellterrier,pekingese,pug|0,3:borderterrier,cairnterrier,cavalierkingcharlesspaniel,frenchbulldog,nederlandsekooikerhondje,shiba,shihtzu,westhighlandwhiteterrier|0.161513,1.940527:boxer|0,0:boykinspaniel,chihuahua,continentaltoyspaniel,germanspitz,miniaturepoodle,pomeranian,yorkshireterrier|0.19474,0.61053:chesapeakebayretriever|0.17857,1.46429:dachshund|0.131034,2.570115:dalmatian,germanshorthairedpointingdog,greyster,hungarianshorthairedpointervizsla,hungarianwirehairedpointer|0.177094,1.321368:dobermann|0.17857,1.57143:englishcockerspaniel|0.15415,1.667984:englishpointer,englishsetter|0.12587,1.04545:englishspringerspaniel|0.1523,1.7846:finnishlapponiandog|0.12196,2.04969:finnishspitz|0.151538,1.759231:flatcoatedretriever|0.06667,5.38889:greatdane|0.139382,2.079708:greenlanddog|0.1544,1.6618:haldenhound,hygenhound|0.07013,5.363636:irishwolfhound|0.21429,1.5:japanesechin,lhasaapso,littleliondog|0.14288,2.338:labradorretriever|0.084274,4.429435:leonberger|0.085081,4.514113:newfoundland|0.18182,1.1558:norwegianbuhund|0.148718,1.85641:norwegianelkhoundblack,norwegianelkhoundgrey|0.1512,1.7581:oldenglishsheepdog|0,5:petitbassetgriffonvendeen|0.1722,1.331:poodle|0.1486,1.548:portuguesewaterdog,spanishwaterdog|0.097436,4.5641:pyreneanmountaindog|0.14706,1.5:pyreneansheepdogsmoothfaced|0.170498,1.609743:rhodesianridgeback|0.135523,2.919:rottweiler|0.16502,1.4832:saluki|0.16,1.563:samoyed|0.4,0.3:schipperke|0.1421,1.9632:schnauzer|0.28333,1.52222:scottishterrier|0.16429,1.69048:shetlandsheepdog|0.133279,2.461138:stbernard|0.14964,2.548:staffordshirebullterrier|0.155385,2.009231:weimaraner|0.1544,1.4338:welshcorgicardigan|0.19048,2.119:welshcorgipembroke|0.1515,1.3939:welshspringerspaniel|0.071429,2.524:whippet'.split('|').forEach(group => {
  const divider = group.indexOf(':');
  const [adjustment, intercept] = group.slice(0, divider).split(',').map(Number);
  group.slice(divider + 1).split(',').forEach(breedKey => {
    NSD_FREEMOTION_OFFICIAL_COEFFICIENTS[breedKey] = { adjustment, intercept };
  });
});
window.BeitoFreemotionOfficialCoefficients = Object.freeze(NSD_FREEMOTION_OFFICIAL_COEFFICIENTS);
// Official size bands per breed and whole-kilogram weight, derived from the manufacturer's formula.
// The source calculator returns size 1 for 1.9 < kg < 4; otherwise it rounds intercept + adjustment * kg.
const NSD_OFFICIAL_WEIGHT_RANGES = Object.create(null);
for (const [breedKey, formula] of Object.entries(NSD_FREEMOTION_OFFICIAL_COEFFICIENTS)) {
  const ranges = [];
  for (let kg = 1; kg <= 60; kg += 1) {
    const rawSize = kg > 1.9 && kg < 4 ? 1 : Math.round(formula.intercept + formula.adjustment * kg);
    const size = rawSize >= 1 && rawSize <= 10 ? String(rawSize) : null;
    const last = ranges[ranges.length - 1];
    if (last && last.size === size && last.maxKg === kg - 1) last.maxKg = kg;
    else ranges.push({ minKg: kg, maxKg: kg, size });
  }
  NSD_OFFICIAL_WEIGHT_RANGES[breedKey] = Object.freeze(ranges.map(range => Object.freeze(range)));
}
window.BeitoFreemotionOfficialWeightRanges = Object.freeze(NSD_OFFICIAL_WEIGHT_RANGES);
window.BeitoFreemotionOfficialSizeAtWeight = function(breed, weightKg) {
  const formula = NSD_FREEMOTION_OFFICIAL_COEFFICIENTS[normalizeNsdBreedKey(breed)];
  const weight = Number(String(weightKg ?? '').trim().replace(',', '.'));
  if (!formula || !Number.isFinite(weight) || weight < 1 || weight > 60) return null;
  const size = weight > 1.9 && weight < 4 ? 1 : Math.round(formula.intercept + formula.adjustment * weight);
  return size >= 1 && size <= 10 ? String(size) : null;
};

function getFreemotionManufacturerCheck(profile, result, measurements, config, BREED_ALIASES) {
if (String(config.key || '') !== 'freemotion' || !result?.selected) return null;
const breed = String(profile?.breed || '').trim();
const weight = Number(String(profile?.weight ?? '').trim().replace(',', '.'));
if (!breed || !Number.isFinite(weight) || weight <= 0) return null;
const normalizedBreed = normalizeNsdBreedKey(breed);
const candidates = [breed];
const aliasEntry = Object.entries(BREED_ALIASES || {}).find(([alias, canonical]) =>
normalizeNsdBreedKey(alias) === normalizedBreed || normalizeNsdBreedKey(canonical) === normalizedBreed
);
if (aliasEntry) candidates.push(aliasEntry[0], aliasEntry[1]);
for (const [alias, canonical] of Object.entries(NSD_FREEMOTION_BREED_ALIASES)) {
if (candidates.some(candidate =>
normalizeNsdBreedKey(candidate) === normalizeNsdBreedKey(alias) ||
normalizeNsdBreedKey(candidate) === normalizeNsdBreedKey(canonical)
)) candidates.push(alias, canonical);
}
const officialFormulaKey = candidates.map(normalizeNsdBreedKey).find(key => NSD_FREEMOTION_OFFICIAL_COEFFICIENTS[key]);
const officialFormula = officialFormulaKey ? NSD_FREEMOTION_OFFICIAL_COEFFICIENTS[officialFormulaKey] : null;
const measuredSize = String(result.selected.size);
if (officialFormula) {
const exactSize = weight > 1.9 && weight < 4
? 1
: officialFormula.intercept + officialFormula.adjustment * weight;
const integerRange = Number.isInteger(weight) && weight >= 1 && weight <= 60
? NSD_OFFICIAL_WEIGHT_RANGES[officialFormulaKey]?.find(range => weight >= range.minKg && weight <= range.maxKg)
: null;
const recommendedSize = integerRange
? (integerRange.size === null ? null : Number(integerRange.size))
: Math.round(exactSize);
if (recommendedSize === null || recommendedSize < 1 || recommendedSize > 10) {
return {
outcome: 'no_recommendation',
breed,
weightKg: weight,
measuredSize,
neckCm: Number(measurements?.neck)
};
}
if (measuredSize === String(recommendedSize)) return null;
return {
outcome: 'size_mismatch',
breed,
weightKg: weight,
recommendedSize: String(recommendedSize),
measuredSize,
neckCm: Number(measurements?.neck)
};
}
const legacyAlias = Object.entries(BREED_ALIASES || {}).find(([alias]) =>
normalizeNsdBreedKey(alias) === normalizedBreed
);
let canonicalBreed = legacyAlias ? legacyAlias[1] : breed;
const explicitAlias = Object.entries(NSD_FREEMOTION_BREED_ALIASES).find(([alias]) =>
normalizeNsdBreedKey(alias) === normalizeNsdBreedKey(canonicalBreed) ||
normalizeNsdBreedKey(alias) === normalizedBreed
);
if (explicitAlias) canonicalBreed = explicitAlias[1];
const tableBreed = Object.keys((window.BeitoFreemotionWeightSize || {})).find(name =>
normalizeNsdBreedKey(name) === normalizeNsdBreedKey(canonicalBreed)
);
if (!tableBreed) return null;
const lookupWeight = Math.round(weight);
const expectedRange = (window.BeitoFreemotionWeightSize || {})[tableBreed]
.find(([minKg,maxKg]) => lookupWeight >= minKg && lookupWeight <= maxKg);
if (!expectedRange) return null;
if (expectedRange[2] === null) {
return {
outcome: 'no_recommendation',
breed,
weightKg: weight,
measuredSize,
neckCm: Number(measurements?.neck)
};
}
const recommendedSize = String(expectedRange[2]);
if (measuredSize === recommendedSize) return null;
return {
outcome: 'size_mismatch',
breed,
weightKg: weight,
recommendedSize,
measuredSize,
neckCm: Number(measurements?.neck)
};
}
window.BeitoFreemotionManufacturerCheck = getFreemotionManufacturerCheck;
